import { render } from "./EmployeeTrackerLogCard.vue?vue&type=template&id=78faa70c&scoped=true"
import script from "./EmployeeTrackerLogCard.vue?vue&type=script&lang=js"
export * from "./EmployeeTrackerLogCard.vue?vue&type=script&lang=js"

import "./tracker-log-card.scss?vue&type=style&index=0&id=78faa70c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78faa70c"]])

export default __exports__